"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiGroup = _interopRequireDefault(require("./ApiGroup"));
class Accounts extends _ApiGroup.default {
  /**
   * List Accounts belonging to the current user.
   */
  list() {
    return this.request({
      url: '/accounts'
    }).then(response => response.data.data);
  }

  /**
   * Generates a new Ethereum account.
   *
   * @param owner (Optional) Account owner's user ID
   * @param makeDefault (Optional) Make the account the user's default account
   */
  create(owner, makeDefault = false) {
    let data = {
      'default': makeDefault
    };
    if (owner) {
      data.owner = owner;
    }
    return this.request({
      method: 'post',
      url: '/accounts',
      data
    }).then(response => response.data.data);
  }

  /**
   * Get a specific Account by its ID.
   */
  get(id) {
    return this.request({
      url: `/accounts/${id}`
    }).then(response => response.data.data);
  }

  /**
   * Get the default account for the authenticated user.
   */
  getDefault() {
    return this.request({
      url: `/accounts/default`
    }).then(response => response.data.data);
  }
  balance(network = 1, address) {
    let url;
    if (!address) {
      url = `/accounts/default/balance/${network}`;
    } else {
      url = `/accounts/${address}/balance/${network}`;
    }
    return this.request({
      url
    }).then(response => response.data.data);
  }
  signMessage(message, accountId) {
    let url;
    if (!accountId) {
      url = `/accounts/default/sign`;
    } else {
      url = `/accounts/${accountId}/sign`;
    }
    let data = {
      message
    };
    return this.request({
      method: "POST",
      url,
      data
    }).then(response => response.data.data);
  }
  signData(hexData, accountId) {
    let url;
    if (!accountId) {
      url = `/accounts/default/sign`;
    } else {
      url = `/accounts/${accountId}/sign`;
    }
    let data = {
      data: hexData
    };
    return this.request({
      method: "POST",
      url,
      data
    }).then(response => response.data.data);
  }
}
exports.default = Accounts;
//# sourceMappingURL=Accounts.js.map